export default __webpack_public_path__ + "static/media/eng.e4735fa8.jpg";